export default __webpack_public_path__ + "assets/9475cb0c1cf5b56fb1a0c9262d38756e.svg";